// extracted by mini-css-extract-plugin
var _1 = "cwnA7";
var _2 = "yZwEf";
var _3 = "U17Yn";
var _4 = "E9w46";
var _5 = "gMHsR";
var _6 = "z600g";
var _7 = "DodVu";
var _8 = "Yik5g";
var _9 = "PB0l5";
var _a = "YrfbJ";
var _b = "jKeSS";
var _c = "kcmre";
var _d = "wU5_s";
var _e = "cb24u";
var _f = "bRjfe";
var _10 = "CJkG0";
var _11 = "LmbpH";
var _12 = "MkgNk";
var _13 = "Gifxs";
var _14 = "wW1xC";
export { _1 as "compact", _2 as "firstRow", _3 as "firstRowGap", _4 as "firstRowLine", _5 as "full", _6 as "mailListShimmerContainer", _7 as "paddingFirstMessage", _8 as "paddingMessage", _9 as "personaCircle", _a as "personaGap", _b as "secondRow", _c as "secondRowEndGap", _d as "secondRowEndLine", _e as "secondRowGap", _f as "secondRowMainLine", _10 as "secondRowText", _11 as "skeletonContainer", _12 as "thirdRow", _13 as "thirdRowGap", _14 as "thirdRowLine" }
